<template>
    <ul class="blue-menu" :class="{ 'blue-menu_full': fullWidth, small }">
        <li
            class="blue-menu__item"
            :class="{
                disabled: view.disabled
            }"
            :key="index"
            v-for="(view, index) in tabs"
        >
            <router-link
                v-if="!withEmit"
                :to="buildRoute(view)"
                :class="{
                    active: activeTab(view)
                }"
            >
                <template v-if="view.key">
                    {{ t(`${keyStart}.${view.key}`) }}
                </template>
                <template v-else>
                    {{ view.title }}
                </template>
            </router-link>
            <span
                @click="handleClick($event, view)"
                v-else
                :class="{
                    active: activeTab(view)
                }"
            >
                <template v-if="view.key">
                    {{ t(`${keyStart}.${view.key}`) }}
                </template>
                <template v-else>
                    {{ view.title }}
                </template>
            </span>
        </li>
        <slot></slot>
    </ul>
</template>

<script>
export default {
    name: "BlueTabs",
    props: {
        tabs: {
            type: Array,
            default: () => []
        },
        active: {
            type: Object,
            default: null
        },
        keyStart: {
            type: String,
            default: "quiz"
        },
        withEmit: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        fullWidth: {
            type: Boolean,
            default: false
        },
        useQueryParam: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        buildRoute(view) {
            if (this.useQueryParam && view.queryKey) {
                return {
                    name: this.$route.name,
                    query: { ...this.$route.query, tab: view.queryKey }
                }
            }
            return { name: view.name, query: view.query }
        },
        handleClick(event, view) {
            if (this.withEmit) {
                event.preventDefault()
                this.$emit("set", view)
            }
        },
        activeTab(view) {
            if (this.useQueryParam && view.queryKey) {
                return this.$route.query.tab === view.queryKey
            }
            if (this.active) {
                if (this.active.id) {
                    return this.active.id === view.id
                }
                if (this.active.value) {
                    return this.active.value === view.value
                }
                return false
            }
            return this.$route && this.$route.matched.find(e => e.name === view.name)
        }
    }
}
</script>

<style scoped lang="sass">
.blue-menu
    display: flex
    align-items: center
    position: relative
    @media (max-width: 639px)
        align-items: stretch
    @media (max-width: 480px)
        margin: 10px

    &:after
        content: ''
        background: #DDDDDD
        border-radius: 100px
        width: 100%
        height: 1px
        position: absolute
        bottom: 0
        left: 0
    @media (max-width: 460px)
        overflow: auto
    &__item
        &::marker
            content: none
        a, span
            cursor: pointer
            font-family: 'Inter', sans-serif
            font-weight: 400
            font-size: 14px
            line-height: 150%
            color: #323030
            display: block
            padding: 0 15px 20px
            margin-right: 30px
            position: relative
            &.active, &:hover
                &:after
                    content: ''
                    background: #3965FF
                    border-radius: 100px
                    width: 100%
                    height: 1px
                    position: absolute
                    bottom: 0
                    left: 0
                    z-index: 2
            @media (max-width: 740px)
                width: max-content
                margin-right: 10px
            @media (max-width: 639px)
                width: auto
                text-align: center
                height: 100%
                display: flex
                align-items: center
                padding: 0 15px 10px
            @media (max-width: 440px)
                padding: 0 10px 10px
                font-size: 12px
                margin-right: 0
            @media (max-width: 380px)
                padding: 0 8px 14px
        &:last-child
            a, span
                margin-right: 0 !important
    &.small
        .blue-menu__item
            a
                padding: 10px 15px 12px
                font-family: 'Lato', sans-serif
    &_full
        .blue-menu__item
            width: 100%
            text-align: center
</style>
